var version = '0.4.3';
export { version };
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@tensorflow/tfjs-converter/dist-es6/version.js
// module id = 786
// module chunks = 0